module.exports = __webpack_public_path__ + "p3_img1.jpg?7265a10c59e99247ab22712398d3dbcc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p3/p3_img1.jpg
// module id = 103
// module chunks = 0